<template>
  <div class="rs-filter-bar">
    <div class="rs-filter-bar__main">
      <div class="d-flex align-items-center">
        <slot name="favorite" />
        <RsFormInput
          v-if="!noSearch"
          v-model="input"
          type="search"
          icon="search"
          :debounce="800"
          :label="searchLabelText"
          @input="$emit('input', input)"
        />
        <slot name="filters" />
        <div class="ml-auto">
          <div v-if="hasOrientation">
            <RsButton
              :class="{ activeIcon: isActive == 'grid' }"
              variant="primary"
              plain
              icon="th-large"
              @click="changeOrientation('grid')"
            />
            <RsButton
              :class="{ activeIcon: isActive == 'list' }"
              variant="primary"
              plain
              icon="th-list"
              @click="changeOrientation('list')"
            />
          </div>
          <slot name="btn" />
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsFilterBar',

  props: {
    hasOrientation: {
      type: Boolean,
      default: false,
    },
    noSearch: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    searchLabelText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      favorite: 0,
      isActive: 'grid',
      input: `${this.value}`,
    };
  },
  methods: {
    changeOrientation(value: any) {
      this.isActive = value;
      this.$eventBus.$emit('orientation', value);
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.rs-filter-bar {
  padding: 1rem;
  border: 1px solid $extra-light-gray;
  border-radius: $global-radius;
  background-color: $white;
  .rs-input,
  .rs-select,
  .rs-dropdown-checkboxes {
    margin: 0 1rem 0 0;
  }
  .activeIcon {
    color: $secondary-color;
  }
}
</style>
